import React from 'react'
import { actionButtonsColumnProps, BooleanColumn, BsrsGrid, Column, EnumFilterCell, FlagsEnumCell } from '@/components/BsrsGrid'
import Resx from '@/components/Resx'
import { Main, MainBody, MainTop, MainTopLeft, MainTopTitle } from '@/components/Layout'
import context from '@/context'
import { CreateChangeItem } from '@/components/changeRequests/createChangeItem'
import { useLocalization } from '@/hooks/localization'
import { associationTypes } from '@/enums/associationTypes'
import { GridCell } from '@progress/kendo-react-grid'
import { localized } from '@/decorators/localized'
import { DropDownFilterCellLocalized } from '@/components/BsrsGrid/BsrsGrid.DropDownFilterCell'
import ErrorBoundary from '@/components/ErrorBoundary'

@localized()
class RelatedInstitutionsCell extends GridCell {
  render () {
    const value = this.props.dataItem[this.props.field]

    if (value && value.length) {
      const valuesToRender = value.map(x => this.props.localizeValue(x.name, x.latinName))
      let stringToRender = ''

      for (let i = 0; i < valuesToRender.length; i++) {
        const valueToRender = valuesToRender[i]

        if (i === (valuesToRender.length - 1)) {
          stringToRender += valueToRender
        } else {
          stringToRender += `${valueToRender}, `
        }
      }

      return <td>{stringToRender}</td>
    }

    return <td />
  }
}

function IndividualList () {
  const { localize, locale } = useLocalization()
  const { enumName } = associationTypes

  const relatedInstitutionsCellExport = ({ dataItem, field }) => {
    const institutions = dataItem[field]
    if (Array.isArray(institutions) && institutions.length > 0) {
      return institutions.map(inst => inst.name || inst.latinName || '').join(', ')
    } else {
      return ''
    }
  }

  return <Main>
    <MainTop>
      <MainTopTitle>
        <Resx name='Individuals.Title' />
      </MainTopTitle>
      <MainTopLeft>
        <CreateChangeItem buttonText='Individuals.CreateNew'
          scope='Individuals'
          additionalPermission='CanCreateIndividuals' />
      </MainTopLeft>
    </MainTop>

    <MainBody>
      <ErrorBoundary>
        <BsrsGrid persistenceId={'individuals'} dataSource={context.api.individualService.getIndividuals} >
          <Column field='firstName' title={localize('Individuals.Name')} width='250px' />
          <Column field='fatherName' title={localize('Individuals.FatherName')} />
          <Column field='grandfatherName' title={localize('Individuals.GrandfatherName')} />
          <Column field='greatGrandfatherName' title={localize('Individuals.GreatGrandfatherName')} />
          <Column field='surname' title={localize('Individuals.Surname')} />
          <Column field='association' title={localize('Individuals.Association')}
            filterCell={EnumFilterCell({ localize, enumName }, associationTypes.values)}
            cell={FlagsEnumCell({ localize, enumObject: associationTypes })}
            enumName={enumName} />
          <Column field='relatedInstitutions' title={localize('Individuals.RelatedInstitutions')}
            cell={RelatedInstitutionsCell}
            cellExport={relatedInstitutionsCellExport}
            filterCell={DropDownFilterCellLocalized(context.api.institutionService.getLookup, 'name', 'latinName', locale)}
            width='300px'
            sortable={false} />
          {BooleanColumn({ field: 'isUser', title: localize('Individuals.IsUser'), width: '100px' })}
          {BooleanColumn({ field: 'isActive', title: localize('Common.IsActive'), width: '100px' })}
          <Column {...actionButtonsColumnProps([{ url: x => `/individuals/${x.id}`, icon: 'show' }])} />
        </BsrsGrid>
      </ErrorBoundary>
    </MainBody>
  </Main>
}

export {
  IndividualList
}



// WEBPACK FOOTER //
// ./src/internal-app/pages/individuals/list.js